import { GameServices } from '../services/game-services';
import { BlackjackMainScene } from '../scenes/blackjack-main-scene';
import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';
import { UiButtonType } from 'game-logic';
import { GameBoardView } from '../interface/game-board/game-board-view';
import { GameBoardViewModel } from '../interface/game-board/game-board-view-model';

export class SceneController {
  private readonly gameBoardViewModel: GameBoardViewModel;
  private gameBoardView?: GameBoardView;

  constructor(private readonly gameServices: GameServices) {
    this.gameBoardViewModel = new GameBoardViewModel(gameServices);
  }

  public initGraphics(scene: BlackjackMainScene) {
    this.gameBoardView = new GameBoardView(scene, 0, 0, this.gameBoardViewModel);
    this.onResize(scene.currentGameSizeMetrics);

    // scene.input.keyboard?.on('keydown-K', this.gameServices.blackjackGameRunner.copyTestCase, this);
  }

  public onResize(gameSizeMetrics: GameSizeMetrics) {
    this.gameBoardView?.onResize(gameSizeMetrics);
  }

  public onSceneReady() {
    this.gameServices.gameListener.onGameLoaded();
  }

  public showStartButton(showButton: boolean): void {
    this.gameBoardViewModel.showStartButton(showButton);
  }

  public startRemoteRound(moves: string[], logicVersion: number): void {
    if (this.gameServices.useLocalDealer) {
      this.gameServices.blackjackGameRunner.startNewLocalRound();
      return;
    }

    if (moves.length > 0) {
      this.gameServices.blackjackGameRunner.startExistingRemoteRound(moves, logicVersion);
      return;
    }
    this.gameServices.blackjackGameRunner.startNewRemoteRound(logicVersion);
  }

  public autoStartGame(): void {
    this.gameServices.gameListener.onStartGame();
  }

  public resetGameScene(): void {
    this.gameBoardViewModel.resetGameScene();
  }

  public uiButtonTapped(uiButton: UiButtonType): void {
    this.gameServices.interfaceController.uiButtonTapped(uiButton);
  }
}
